/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomguestschartempty4Inputs */

const en_statsroomguestschartempty4 = /** @type {(inputs: Statsroomguestschartempty4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No guest has been in a Live Room in the last 12 weeks.`)
};

const de_statsroomguestschartempty4 = /** @type {(inputs: Statsroomguestschartempty4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In den letzten 12 Wochen war noch kein Gast in einem Live Room.`)
};

/**
* | output |
* | --- |
* | "No guest has been in a Live Room in the last 12 weeks." |
*
* @param {Statsroomguestschartempty4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomguestschartempty4 = /** @type {((inputs?: Statsroomguestschartempty4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomguestschartempty4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomguestschartempty4(inputs)
	return de_statsroomguestschartempty4(inputs)
});
export { statsroomguestschartempty4 as "statsRoomGuestsChartEmpty" }